export default {
  "content": "<g clip-path=\"url(#clip0_15_14421)\"><path d=\"M20 1.667v16.666a.833.833 0 01-.833.834H.833A.834.834 0 010 18.333V1.667A.833.833 0 01.833.833h18.334a.833.833 0 01.833.834zm-5.833 1.666a.833.833 0 101.666 0 .833.833 0 00-1.666 0zm-2.5 0a.833.833 0 101.666 0 .833.833 0 00-1.666 0zm6.666 2.5H1.688V17.5h16.645V5.833zm0-2.5a.833.833 0 10-1.666 0 .833.833 0 001.666 0zM7.5 15.757l6.386-3.59a.583.583 0 000-.994L7.5 7.577a.557.557 0 00-.833.5v7.186a.557.557 0 00.833.494z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"clip0_15_14421\"><path fill=\"#fff\" d=\"M0 0h20v20H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};